// PnLCharts.tsx (public wrappers)
import React from "react";
import PnLChartsBase from "./PnLChartsBase";

interface ChartWithCobProps {
  cob_date?: Date | null;
  height?: number;
  page?: string | null;
}

interface PnLVarChartProps extends ChartWithCobProps {
  element_type?: string;
  pnl_type?: string;
  hide_legend_button?: boolean;
}

export const PnLPerformanceDashboardChart: React.FC<ChartWithCobProps> = ({ cob_date, height }) => (
  <PnLChartsBase page="dashboard" cob_date={cob_date} height={height} />
);

export const PnLCurrentYearChart: React.FC<ChartWithCobProps> = ({ cob_date, height }) => (
  <PnLChartsBase page="charts" cob_date={cob_date} height={height} />
);

export const PnLHistoryChart: React.FC<ChartWithCobProps> = ({ height }) => (
  <PnLChartsBase page="history" height={height} />
);

export const PnLVarChart: React.FC<PnLVarChartProps> = ({ cob_date, element_type = "Market Maker Total", pnl_type, hide_legend_button, height }) => (
  <PnLChartsBase
    page="dashboard"
    cob_date={cob_date}
    element_type={element_type}
    pnl_type={pnl_type ?? "standalone_var"}
    hide_legend_button={hide_legend_button}
    height={height}
  />
);


// Backward-compatible default export
const PnLCharts = (props: any) => <PnLChartsBase {...props} />;
export default PnLCharts;
